import { useFilter } from "../../features/filter/hook";
import dataIcon from "./assets/data.svg";
import ConsumptionChart from "../../features/Jouly/components/ComsumptionChart";
import {
  CreditChart,
  LastCreditValue,
} from "../../features/Jouly/components/Credit";

import Voltage from "../../features/Jouly/components/Voltage";
import { useConsumption } from "../../features/Jouly/hooks";

import styles from "./ConsumptionPage.module.scss";
import { useEffect, useState } from "react";
import Current from "../../features/Jouly/components/Current";
import Frequency from "../../features/Jouly/components/Frequency";

export default function ConsumptionPage({
  headerFixed = false,
  defaultDeviceEui ,
}: {
  headerFixed?: boolean;
  defaultDeviceEui?: string;
}) {
  const { filter } = useFilter();
  const {
    lastConsumptionQuery: {
      isLoading: isLoadingLastConsumption,
      data: lastconsumptionData,
    },
  } = useConsumption();

  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!filter?.device_name || filter?.device_name === "") {
      setMessage("Veuillez entrer un compteur");
    } else if (
      filter?.device_name &&
      !isLoadingLastConsumption &&
      !lastconsumptionData?.[0]
    ) {
      setMessage("Compteur introuvable");
    } else {
      setMessage(null);
    }
  }, [filter, isLoadingLastConsumption, lastconsumptionData]);

  return (
    <>
      <header
        className={[
          styles["header"],
          headerFixed ? styles["header--fixed"] : "",
        ].join(" ")}
      >
        <div className={[styles["header__content"],   headerFixed ? styles["header__content--no-margin"]: ""].join(" ")}>
          <div
            className={[
              styles["filter-item"],
              styles["filter-item--left"],
            ].join(" ")}
          >
            <h1 className={[styles["filter-item__title"]].join(" ")}>
              <ConsumptionChart.CounterSelectedInfo.DeviceName />
            </h1>
          </div>
          <div
            className={[
              styles["filter-item"],
              styles["filter-item--right"],
            ].join(" ")}
          >
            <div className={styles["filter-item__item"]}>
              <ConsumptionChart.TimeWindowFilter />
            </div>
            <div className={styles["filter-item__item"]}>
              <ConsumptionChart.CounterFilter defaultDeviceEui={defaultDeviceEui}/>
            </div>
          </div>
        </div>
      </header>

      <div className={[styles["page"], headerFixed ? styles["page--padding-top"] : ""].join(" ")}>
        <div className={styles["page__content"]}>
          {filter?.device_name &&
          (isLoadingLastConsumption || lastconsumptionData?.[0]) ? (
            <>
              <div className={styles["counter-info"]}>
                <div
                  className={[
                    styles["counter-info__item"],
                    styles["container"],
                    styles["container--primary"],
                  ].join(" ")}
                >
                  <h2 className={[styles["container__sub-title"]].join(" ")}>
                    Énergie total
                  </h2>
                  <p className={[styles["container__desc"]].join(" ")}>
                    <ConsumptionChart.CounterSelectedInfo.LastConsumptionValue />{" "}
                    <span>kWh</span>
                  </p>
                </div>
                <div
                  className={[
                    styles["counter-info__item"],
                    styles["container"],
                  ].join(" ")}
                >
                  <h2 className={[styles["container__sub-title"]].join(" ")}>
                    Crédit Restant
                  </h2>
                  <p className={[styles["container__desc"]].join(" ")}>
                    <LastCreditValue />
                    <span>kWh</span>
                  </p>
                </div>
                <div
                  className={[
                    styles["counter-info__item"],
                    styles["container"],
                  ].join(" ")}
                >
                  <h2 className={[styles["container__sub-title"]].join(" ")}>
                    Voltage Actuel
                  </h2>
                  <p className={[styles["container__desc"]].join(" ")}>
                    <Voltage.LastValue />
                    <span>V</span>
                  </p>
                </div>
              </div>

              <div className={[styles["chart"], styles["container"]].join(" ")}>
                <div className={styles["chart__header"]}>
                  <h2 className={styles["chart__title"]}>
                    Consommation d'Énergie (kWh)
                  </h2>
                </div>
                <div className={styles["chart__content"]}>
                  <ConsumptionChart.Chart />
                </div>
              </div>



              
        <div className={[styles["chart"], styles["container"]].join(" ")}>
          <div className={styles["chart__header"]}>
            <h2 className={styles["chart__title"]}>Voltage</h2>
          </div>
          <div className={styles["chart__content"]}>
            <Voltage.Chart />
          </div>
        </div>

        <div className={[styles["chart"], styles["container"]].join(" ")}>
          <div className={styles["chart__header"]}>
            <h2 className={styles["chart__title"]}>Courant</h2>
          </div>
          <div className={styles["chart__content"]}>
            <Current.Chart />
          </div>
        </div>

        <div className={[styles["chart"], styles["container"]].join(" ")}>
          <div className={styles["chart__header"]}>
            <h2 className={styles["chart__title"]}>Fréquence</h2>
          </div>
          <div className={styles["chart__content"]}>
            <Frequency.Chart />
          </div>
        </div>
        <div className={[styles["chart"], styles["container"]].join(" ")}>
                <div className={styles["chart__header"]}>
                  <h2 className={styles["chart__title"]}>Crédit (kWh)</h2>
                </div>
                <div className={styles["chart__content"]}>
                  <CreditChart />
                </div>
              </div>
        
            </>
          ) : (
            <div className={styles["message"]}>
              <img
                className={styles["message__icon"]}
                src={dataIcon}
                alt="data"
              />
              <p className={styles["message__text"]}>Pas de données</p>
              <p> {message}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
